var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadQueries(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-577 -303.001)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.608 0.609)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(576 301.999)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    transform: "translate(0.392 0.393)",
    fill: "#eff1f5"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(581.707 308.821)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.416,9.971a.426.426,0,0,1-.309-.132L6.118,6.707a.427.427,0,0,1,.309-.722H7.992V2.712A.713.713,0,0,1,8.7,2h1.423a.713.713,0,0,1,.712.712V5.985H12.4a.427.427,0,0,1,.309.722L9.724,9.838A.426.426,0,0,1,9.416,9.971Z",
    transform: "translate(-2.584 -2)",
    fill: "#1f2f3d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.667,19.765H1a.907.907,0,0,1-1-.772v-.221A.907.907,0,0,1,1,18H12.667a.907.907,0,0,1,1,.772v.221A.907.907,0,0,1,12.667,19.765Z",
    transform: "translate(0 -8.379)",
    fill: "#1f2f3d"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadQueries);
export default __webpack_public_path__ + "static/media/download-queries.29dfdf2afd7545cab0654ff4525a037b.svg";
export { ForwardRef as ReactComponent };